export default __webpack_public_path__ + "static/media/check-tick.4870a347.svg";